export default __webpack_public_path__ + "68815be757896530fc1834f00a2ef990.png";